import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {AnimatedLineDrawing} from "@khanacademy/khannotations";
import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries} from "@khan/shared-styles";
import {staticUrl} from "@khan/urls";

import {MarketingColors} from "#marketing-content-shared-package/constants.ts";
import Parallax, {Layer} from "#marketing-content-shared-package/parallax.tsx";

import {
    AXES,
    LEAF_CLIP,
    ORANGE_CLIP,
    PLANET_CLIP,
    TICK_1,
    TICK_2,
    TICK_3,
    TICK_4,
    TICK_5,
    TICK_6,
    TICK_7,
} from "./graph.data.ts";

const Axes = () => (
    <React.Fragment>
        <AnimatedLineDrawing
            bare={true}
            d={AXES}
            pathStyle={{
                stroke: MarketingColors.highlightTeal,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
            }}
            animation={{
                animation: "speed",
                delay: 600,
                position: "absolute",
                speed: 20,
            }}
            delayRatio={0}
            title="Axes"
        />
        <AnimatedLineDrawing
            bare={true}
            d={TICK_1 + TICK_2 + TICK_3 + TICK_4 + TICK_5 + TICK_6 + TICK_7}
            pathStyle={{
                stroke: MarketingColors.highlightTeal,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
            }}
            animation={{
                animation: "speed",
                delay: 0,
                position: "absolute",
                speed: 4,
            }}
            delayRatio={0}
            title="Axes"
        />
    </React.Fragment>
);

const Bars = () => {
    const greenBars = [
        {
            fill: MarketingColors.highlightTeal,
            height: 248.436,
            rx: "3",
            width: "24.5369",
            x: 425.073,
            y: 142.443,
        },
        {
            fill: "#92DBBD",
            height: 275.281,
            rx: "3",
            width: "24.5369",
            x: 466.477,
            y: 152.411,
        },
        {
            fill: MarketingColors.highlightTeal,
            height: 285.242,
            rx: "3",
            width: "24.5369",
            x: 549.29,
            y: 142.443,
        },
        {
            fill: MarketingColors.highlightTeal,
            height: 240.769,
            rx: "3",
            width: "24.5369",
            x: 343.023,
            y: 134.775,
        },
        {
            fill: "#2CB78E",
            height: 280.649,
            rx: "3",
            width: "24.5369",
            x: 507.884,
            y: 147.044,
        },
        {
            fill: "#2CB78E",
            height: 200.85,
            rx: "3",
            width: "24.5369",
            x: 384.433,
            y: 147.044,
        },
        {
            fill: MarketingColors.highlightTeal,
            height: 248.436,
            rx: "3",
            width: "24.5369",
            x: 672.74,
            y: 142.443,
        },
        {
            fill: "#92DBBD",
            height: 278.341,
            rx: "3",
            width: "24.5369",
            x: 713.378,
            y: 149.344,
        },
        {
            fill: MarketingColors.highlightTeal,
            height: 287.542,
            rx: "3",
            width: "24.5369",
            x: 796.188,
            y: 140.143,
        },
        {
            fill: MarketingColors.highlightTeal,
            height: 226.2,
            rx: "3",
            width: "24.5369",
            x: 589.928,
            y: 149.345,
        },
        {
            fill: "#2CB78E",
            height: 285.242,
            rx: "3",
            width: "24.5369",
            x: 754.789,
            y: 142.443,
        },
        {
            fill: "#2CB78E",
            height: 200.896,
            rx: "3",
            width: "24.5369",
            x: 631.333,
            y: 147.044,
        },
    ];

    greenBars.sort((a, b) => a.x - b.x);

    return (
        <React.Fragment>
            {greenBars.map((bar, i) => (
                <React.Fragment key={i}>
                    <g
                        key={i}
                        className={css(styles.hoverExpand)}
                        style={{
                            transformOrigin: `50% ${bar.y + bar.height}px`,
                        }}
                    >
                        <rect
                            key={`${i}_under`}
                            fill="#259B78"
                            height={bar.height}
                            rx={bar.rx}
                            width={bar.width}
                            x={bar.x}
                            y={bar.y}
                            className={css(styles.incremental)}
                            style={{
                                animationDelay: `${1400 + i * 100}ms`,
                                transformOrigin: `50% ${bar.y + bar.height}px`,
                            }}
                        />
                        <rect
                            key={i}
                            fill={bar.fill}
                            height={bar.height}
                            rx={bar.rx}
                            width={bar.width}
                            x={bar.x}
                            y={bar.y}
                            className={css(styles.incremental)}
                            style={{
                                animationDelay: `${1400 + i * 100}ms`,
                                transformOrigin: `50% ${bar.y + bar.height}px`,
                            }}
                        />
                    </g>
                </React.Fragment>
            ))}

            <rect
                fill="#CACFE9"
                height="52.6304"
                width="24.5369"
                x="425.071"
                y="375.116"
            />
            <rect
                fill="#CACFE9"
                height="85.5694"
                width="24.5369"
                x="466.875"
                y="342.123"
            />
            <rect
                fill="#CACFE9"
                height="56.1298"
                width="24.5369"
                x="549.29"
                y="371.562"
            />
            <rect
                fill="#CACFE9"
                height="71.7882"
                width="24.5369"
                x="343.021"
                y="355.961"
            />
            <rect
                fill="#CACFE9"
                height="75.0651"
                width="24.5369"
                x="507.884"
                y="352.628"
            />
            <rect
                fill="#CACFE9"
                height="91.4672"
                width="24.5369"
                x="384.434"
                y="336.271"
            />
            <rect
                fill="#CACFE9"
                height="52.6304"
                width="24.5369"
                x="672.739"
                y="375.116"
            />
            <rect
                fill="#CACFE9"
                height="87.2378"
                width="24.5369"
                x="713.378"
                y="340.455"
            />
            <rect
                fill="#CACFE9"
                height="56.1298"
                width="24.5369"
                x="796.19"
                y="371.563"
            />
            <rect
                fill="#CACFE9"
                height="71.7882"
                width="24.5369"
                x="589.928"
                y="355.961"
            />
            <rect
                fill="#CACFE9"
                height="75.0651"
                width="24.5369"
                x="754.789"
                y="352.628"
            />
            <rect
                fill="#CACFE9"
                height="91.4672"
                width="24.5369"
                x="631.336"
                y="336.271"
            />
        </React.Fragment>
    );
};

const Leaf = () => (
    <React.Fragment>
        <mask
            id="lohp_graph_leaf_mask"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            height="243"
            width="272"
            x="511"
            y="0"
        >
            <path d={LEAF_CLIP} fill={color.white} />
        </mask>
        <Layer level={5}>
            <g mask="url(#lohp_graph_leaf_mask)">
                <image
                    href={staticUrl("/images/lohp/graph_leaf_v31.jpeg")}
                    xlinkHref={staticUrl("/images/lohp/graph_leaf_v31.jpeg")}
                    height="242"
                    width="272"
                    x="512"
                />
                /{">"}
            </g>
        </Layer>
    </React.Fragment>
);

const Orange = () => (
    <g style={{mixBlendMode: "multiply"}}>
        <mask
            id="lohp_graph_orange_mask"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            height="202"
            width="364"
            x="162"
            y="347"
        >
            <path d={ORANGE_CLIP} fill="#555" />
        </mask>
        <Layer level={2}>
            <g mask="url(#lohp_graph_orange_mask)">
                <image
                    href={staticUrl("/images/lohp/graph_orange_v31.jpeg")}
                    xlinkHref={staticUrl("images/lohp/graph_orange_v31.jpeg")}
                    height="201.5"
                    width="364.5"
                    x="161"
                    y="347"
                />
            </g>
        </Layer>
    </g>
);

const Planet = () => (
    <React.Fragment>
        <mask
            id="lohp_planet_mask"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            height="106"
            width="107"
            x="0"
            y="431"
        >
            <path d={PLANET_CLIP} fill={color.white} />
        </mask>
        <Layer level={2}>
            <g mask="url(#lohp_planet_mask)">
                <image
                    style={{pointerEvents: "none"}}
                    href={staticUrl("/images/lohp/graph_planet_v31.jpeg")}
                    xlinkHref={staticUrl("/images/lohp/graph_planet_v31.jpeg")}
                    height="108.5"
                    width="110"
                    y="428"
                    x="0"
                />
            </g>
        </Layer>
    </React.Fragment>
);

export default class Graph extends React.PureComponent<Record<any, any>> {
    render(): React.ReactNode {
        return (
            <View className={css(styles.wrapper)}>
                <Parallax
                    width={430}
                    viewBox="0 50 857 430"
                    className={css(styles.graph)}
                >
                    <Leaf />
                    <Layer level={5}>
                        <Axes />
                        <Bars />
                    </Layer>
                    <Orange />
                    <Planet />
                    {/* HACK: delay "student learning" */}
                    <AnimatedLineDrawing
                        d=""
                        bare={true}
                        pathStyle={{}}
                        animation={{
                            animation: "speed",
                            delay: 1100,
                            position: "absolute",
                            speed: 1,
                        }}
                        delayRatio={0}
                        title="Axes"
                    />
                </Parallax>
            </View>
        );
    }
}

const incremental = {
    "0%": {
        transform: "scaleY(0)",
    },
    "100%": {
        transform: "scaleY(1)",
    },
} as const;

const styles = StyleSheet.create({
    wrapper: {
        display: "block",
        [mediaQueries.lgOrLarger]: {
            overflow: "hidden",
            marginRight: -64,
        },

        [mediaQueries.xlOrLarger]: {
            overflow: "visible",
            marginRight: 0,
        },
    },
    graph: {
        [mediaQueries.xlOrLarger]: {
            marginLeft: "-20%",
            width: "150%",
        },
        [mediaQueries.lgOrLarger]: {
            marginLeft: "-20%",
            width: "130%",
        },
    },
    incremental: {
        ":hover": {
            transition: "none",
            opacity: 0.0,
        },
        transition: "opacity 1600ms ease-in-out",
        // @ts-expect-error - TS2322 - Type '{ readonly "0%": { readonly transform: "scaleY(0)"; }; readonly "100%": { readonly transform: "scaleY(1)"; }; }' is not assignable to type 'AnimationName | undefined'.
        animationName: incremental,
        animationDuration: "1200ms",
        animationTimingFunction: "ease-in-out",
        animationFillMode: "both",
    },
    hoverExpand: {
        ":hover": {
            transform: "scaleY(1.2)",
            transition: "transform 20ms linear",
        },
        transition: "transform 1600ms ease-in-out",
    },
});
